// Module
var code = "<template><span element.ref=\"spanElement\" class=\"badge\"><slot></slot></span></template> ";
// Exports
module.exports = code;